import axios from 'axios';
import ModalVideo from 'modal-video'
import 'modal-video/css/modal-video.min.css'
import Swiper from 'swiper'
import SwiperCore, { Pagination, Navigation } from 'swiper/core'
import 'swiper/swiper.scss'

import flatpickr from "flatpickr";
import { non_busy_date } from './shared/date_picker';
require("flatpickr/dist/themes/material_orange.css");

require('sharer.js')
require('fslightbox')

document.addEventListener('DOMContentLoaded', () => {
  SwiperCore.use([Pagination, Navigation])
  const swiper = new Swiper('.swiper-container', {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    allowTouchMove: true,
    slidesPerView: 2,
    spaceBetween: 10,
    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      // when window width is >= 640px
      780: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      // when window width is >= 640px
      960: {
        slidesPerView: 4,
        spaceBetween: 10
      },
    }
  })
  refreshFsLightbox()
  if(document.getElementById('media')){
    axios.get(`${window.location.origin}/v3/users/photos/list_all`, {
      params: {
        user_id: document.getElementById('media').getAttribute('data-id')
      },
    }).then((response) => {
      if(fsLightboxInstances['gallery']){
        response.data.forEach(photo => {
        const lightBoxPhoto = photo.image.large || photo.image.original || photo.image.small
        if(!fsLightboxInstances['gallery'].props.sources.includes(lightBoxPhoto)){
          fsLightboxInstances['gallery'].props.sources.push(lightBoxPhoto)
          fsLightboxInstances['gallery'].props.types.push('image')
        }
        });
      }
    });
  }

  let dataId = document.getElementById('date') ? document.getElementById('date').getAttribute('data-id') : null
  new ModalVideo('.js-modal-video')
  axios.get(`${window.location.origin}/v3/users/busy_days`, {
    params: {
      user_id: dataId
    }
  }).then((response) => {
    flatpickr('#select_date', {
      mode: 'multiple',
      static: true,
      enable: [
        function(date) {
          return non_busy_date(date, response.data)
        }],
      ignoredFocusElements: [document.getElementById('book_artist')],
      onChange: function(selectedDates, dateStr, instance) {
        const nextBtn = document.getElementById('book_artist')
        nextBtn.disabled = selectedDates.length <= 0
      },
      onOpen: [
        function(selectedDates, dateStr, instance){
          let next_btn= document.getElementById("book_artist")
          next_btn.classList.add("next_btn");
        }
      ],
      onClose: function(selectedDates, dateStr, instance){
        let next_btn= document.getElementById("book_artist")
        next_btn.classList.remove("next_btn");
      }
    })
  });
})

document.addEventListener('DOMContentLoaded', () => {
  let top_background = document.getElementById("cover-main");
  let top_info = document.getElementById("cover-user-info");

  window.addEventListener("scroll", () => {
    let top_background_height = top_background.getBoundingClientRect();
    var screen_width = window.innerWidth
      || document.body.clientWidth
      || document.documentElement.clientWidth;
    if(top_background_height["top"] <- 270 && screen_width > 820) {
      top_info.classList.add("sticky-top-info");
      top_info.classList.remove("top-info");
    }
    else {
      top_info.classList.remove("sticky-top-info");
      top_info.classList.add("top-info");
    }
  })
})

// For Talent Card
document.addEventListener("DOMContentLoaded", function(e) {
  let coll = document.getElementsByClassName("collapsible");
  let talent_content = document.getElementsByClassName("talent_content");
  let check_height;
  for (let j = 0; j < coll.length; j++) {
    talent_content[j].classList.toggle("to_hide_arrow");
    check_height=talent_content[j].scrollHeight;
    talent_content[j].classList.toggle("to_hide_arrow");
    if(check_height===24 || check_height<24) {
      coll[j].style.display="none"
    }
  }
  for (let i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function() {
      var talent_content = this.previousElementSibling;
      var arrow = this.children;
      talent_content.classList.toggle("active");
      arrow[0].classList.toggle("transform");
    });
  }

  //  Back to Messenger
  const hideToShowReturnToMessage = document.querySelectorAll("#hide-to-show-return-to-message");
  const mobileReturnToMessenger = document.getElementById("mobile-return-to-messenger");
  const returnToMessenger = document.getElementById("return-to-messenger");
  if(document.referrer.includes("messenger")){
    hideToShowReturnToMessage[0].style.display="none"
    hideToShowReturnToMessage[1].style.display="none"
    returnToMessenger.style.display="block"
  }
  else {
    returnToMessenger.style.display="none"
    mobileReturnToMessenger?.style.setProperty("display", "none", "important");
  }

});

// For Biography
document.addEventListener("DOMContentLoaded", function(e) {
  let biography_collapsible = document.getElementsByClassName("biography_collapsible")[0];
  let show_button = document.getElementsByClassName("show_button");
  let show_more_button = document.getElementsByClassName("show_more_button");
  let show_less_button = document.getElementsByClassName("show_less_button");
  if(biography_collapsible) {
    const fullText = biography_collapsible.textContent;
    const truncatedText = fullText.length > 400 ? fullText.substring(0, 400) : fullText
    let isTruncated = true;
    biography_collapsible.textContent = truncatedText;
    if(biography_collapsible.length <= 400) {
      show_more_button[0].style.display="none"
    }
    for (let i = 0; i < show_button.length; i++) {
      show_button[i].addEventListener("click", function() {
        if (isTruncated) {
          biography_collapsible.textContent = fullText;
        } else{
          biography_collapsible.textContent = truncatedText;
        }
        show_more_button[0].classList.toggle("toggle_show_more");
        show_less_button[0].classList.toggle("toggle_show_less");
        isTruncated = !isTruncated;
      });
    }
  }
});
